import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignDraftAssetsStep =
  () => import(/* webpackChunkName: "campaign-draft-assets-step.async" */ './campaign-draft-assets-step')
    .then(({ CampaignDraftAssetsStepWithI18n }) => CampaignDraftAssetsStepWithI18n);

const DelayedCampaignDraftAssetsLazyRepository =
  () => import(/* webpackChunkName: "campaign-draft-assets-step.async" */ './campaign-draft-assets-lazy-repository')
    .then(({ CampaignDraftAssetsLazyRepository }) => CampaignDraftAssetsLazyRepository);

export const CampaignDraftAssetsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT_ASSETS,
  view: DelayedCampaignDraftAssetsStep,
  repository: DelayedCampaignDraftAssetsLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
